import React, { useEffect, useState } from "react";
import { apiCall_domain } from "../api";
import axios from "axios";
import Spinner from "../Spinner/Spinner";
import { Link } from "react-router-dom";
import Drawer from "@mui/material/Drawer";
import { makeStyles } from "@mui/styles";
import Radio from "@mui/material/Radio";
import List from "@mui/material/List";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import clsx from "clsx";
import Header from "../header";
import ServiceTabs from "./ServiceTabs";
import { FilterComp } from "./FilterComp";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const classes = useStyles;

const Services = () => {
  const [activeTab, setActiveTab] = useState();
  const [state, setState] = useState({});
  const [data, setData] = useState();
  const [categData, setCategData] = useState();
  const [locationdata, setLocationData] = useState();
  const [loading, setLoading] = useState(true);
  const [garagesLoading, setGaragesLoading] = useState(true);
  const [mapLoading, setMapLoading] = useState(true);
  const [category, setCategory] = useState();
  const [location, setLocation] = useState({});
  const [filter, setFilter] = useState(false);
  const [distance, setDistance] = useState([1, 5]);
  const [type, setType] = useState();
  const [open, setOpen] = React.useState(false);
  const [rate, setRate] = useState();
  const [approved, setApproved] = useState();
  const handleOpenLocations = () => setOpen(true);
  const handleCloseLocations = () => setOpen(false);

  const toggleDrawer = (anchor, open, type) => (event) => {
    setActiveTab(type);
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };
  const categhandler = (data) => {
    setCategory(data);
    setGaragesLoading(true);
    setMapLoading(true);
  };
  const addressHandler = (lat, lng) => {
    setLocation({ lat, lng });
    setCategory(null);
  };
  const filterModalToggler = () => {
    setFilter(!filter);
  };
  const changeDistance = (e, newValue) => {
    setDistance([newValue[0], newValue[1]]);
  };
  const filterType = (value) => {
    setType(value);
  };
  const filterRate = (rate) => {
    setRate(rate);
  };
  const getData = () => {
    // setLoading(true);
    setGaragesLoading(true);
    setMapLoading(true);
    const headers = {
      Authorization: localStorage.getItem("Api_key"),
      "content-type": "application/json",
    };
    axios
      .post(
        `${apiCall_domain}/customer/mechanics/search`,
        {
          ...(category && { service: category }),
          ...(location && { lat: location.lat }),
          ...(location && { lang: location.lng }),
          distance: distance[1] - distance[0],
          type: type,
          rate: rate,
          kachar_suggests: approved,
        },
        {
          headers,
        },
      )
      .then((res) => {
        axios
          .get(`${apiCall_domain}/customer/mechanics/services`, { headers })
          .then((res) => {
            setCategData(res.data.data);
            axios
              .get(`${apiCall_domain}/customer/user/addresses`, { headers })
              .then((res) => {
                setLocationData(res.data.data);
                setLoading(false);
                setGaragesLoading(false);
                setMapLoading(false);
              });
          })
          .finally(() => {
            setApproved();
            setLoading(false);
            setGaragesLoading(false);
            setMapLoading(false);
          });
        setData(res.data.data.garages);
      });
  };
  useEffect(() => {
    getData();
  }, [location, category]);
  const submitFilters = () => {
    setFilter(false);
    getData();
  };
  return loading ? (
    <Spinner />
  ) : filter ? (
    <FilterComp
      approved={approved}
      setApproved={setApproved}
      filterRate={filterRate}
      changeDistance={changeDistance}
      distance={distance}
      filterModalToggler={filterModalToggler}
      submitFilters={submitFilters}
      filterType={filterType}
      type={type}
    />
  ) : (
    <>
      {["bottom"].map((anchor) => (
        <>
          <div dir="rtl" key={anchor}>
            <div className="servicesHeader">
              <Link to={"/"}>
                <i className="icon-chevron-right" />
                <span>انتخاب تعمیرگاه</span>
              </Link>
              {/* <div>
                <Link to="/services/history">
                  <i className="icon-cog icons" />
                </Link>
              </div> */}
            </div>
            {/* <Header showSearchBar={true} title={"انتخاب تعمیرگاه"} /> */}
            <div className="serviceTabs">
              <div className="serviceTabsTitle" onClick={handleOpenLocations}>
                <div>
                  <i className="icon-marker" />
                  <span>موقعیت من</span>
                </div>
                <i className="icon-chevron-down" />
              </div>
              <Modal
                className="myAddressServicesModal"
                open={open}
                onClose={handleCloseLocations}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style}>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    className="locationsHeader"
                  >
                    <span>آدرس های من</span>
                    <i className="icon-times" onClick={handleCloseLocations} />
                  </Typography>
                  <Typography
                    id="modal-modal-description"
                    sx={{ mt: 2 }}
                    className="myAddressServicesModal"
                  >
                    {locationdata?.length ? (
                      // <FormControl>
                      //   <RadioGroup
                      //     aria-labelledby="demo-radio-buttons-group-label"
                      //     defaultValue="female"
                      //     name="radio-buttons-group"
                      //   >
                      //     {locationdata.map((data) => (
                      //       <div className="locationRadioRow">
                      //         <FormControlLabel
                      //           value={data.id.toString()}
                      //           control={<Radio />}
                      //           label={data.title}
                      //           className="locationRadioLabel"
                      //           onClick={() => {
                      //             addressHandler(data.lat, data.lng);
                      //           }}
                      //         />
                      //         <div className="locationRadioButton">
                      //           <span className="locationRadioNumber">
                      //             شماره تماس: {data.address_phone}
                      //           </span>
                      //           <span>{data.address}</span>
                      //         </div>
                      //       </div>
                      //     ))}
                      //     <Link to="/profile/addAddress">
                      //       <div className="locationSubmit">
                      //         افزودن آدرس جدید
                      //       </div>
                      //     </Link>
                      //   </RadioGroup>
                      // </FormControl>
                      <fieldset>
                        {locationdata.map((data, index) => (
                          <label
                            className="locationRadioRow"
                            for={index}
                            onClick={() => addressHandler(data.lat, data.lng)}
                          >
                            <div className="locationsTopHalf">
                              <div>
                                <input
                                  type="radio"
                                  name="addressRadio"
                                  id={index}
                                />
                                <span>{data.title}</span>
                              </div>
                              <span className="locationRadioNumber">
                                شماره تماس: {data.address_phone}
                              </span>
                            </div>
                            <span>{data.address}</span>
                          </label>
                        ))}
                      </fieldset>
                    ) : (
                      " ادرسی موجود نیست"
                    )}
                    <Link to="/profile/addAddress">
                      <div className="locationSubmit">افزودن آدرس جدید</div>
                    </Link>
                  </Typography>
                </Box>
              </Modal>

              <i
                className="icon-filters icons filterIcon"
                onClick={filterModalToggler}
              />
              <Link to="/services/history">
                <i className="icon-orders icons filterIcon" />
              </Link>
              {/* <div onClick={toggleDrawer(anchor, true, "categ")}>
                <i className='icon-market icons' />
                <span>دسته بندی ها</span>
              </div> */}
            </div>
            <ServiceTabs
              data={data}
              userLocation={location}
              location={locationdata}
              loading={garagesLoading}
              mapLoading={mapLoading}
              categData={categData}
              method={{
                setGaragesLoading: setGaragesLoading,
                addressHandler: addressHandler,
                categhandler: categhandler,
                setMapLoading: setMapLoading,
              }}
            />
          </div>
        </>
      ))}
    </>
  );
};

export default Services;
